var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdNewuserFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48.69,
    viewBox: "0 0 48 48.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_md_newuser_fail",
    transform: "translate(24 24.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_md_newuser_fail-2",
    "data-name": "ic_md_newuser_fail",
    transform: "translate(-24 -24.345)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11746",
    "data-name": "Ellipse 11746",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#ffe1eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140027",
    "data-name": "Path 140027",
    d: "M31.48,28.59h-.7a13.14,13.14,0,0,1-11.56,0h-.7A9.72,9.72,0,0,0,8.8,38.3V43a24,24,0,0,0,9.75,5.4h12.9A24,24,0,0,0,41.2,43V38.3A9.72,9.72,0,0,0,31.48,28.59Z",
    transform: "translate(-1 -1.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11747",
    "data-name": "Ellipse 11747",
    cx: 9.24,
    cy: 9.24,
    r: 9.24,
    transform: "translate(14.76 5.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140028",
    "data-name": "Path 140028",
    d: "M30.75,9a9.24,9.24,0,0,1-13,13,9.24,9.24,0,1,0,13-13Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140029",
    "data-name": "Path 140029",
    d: "M25,7a9.24,9.24,0,1,1-9.24,9.24A9.24,9.24,0,0,1,25,7m0-2A11.24,11.24,0,1,0,36.24,16.23,11.24,11.24,0,0,0,25,5Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140030",
    "data-name": "Path 140030",
    d: "M33.5,40.2v7.55a24.821,24.821,0,0,0,3.26-1.52Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140031",
    "data-name": "Path 140031",
    d: "M16.54,47.77V40.2l-3.26,6A24.82,24.82,0,0,0,16.54,47.77Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140032",
    "data-name": "Path 140032",
    d: "M22.41,17.25a.87.87,0,0,1-.86-.87V15.27a.87.87,0,0,1,1.73,0v1.11a.87.87,0,0,1-.87.87Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140033",
    "data-name": "Path 140033",
    d: "M27.59,17.25a.87.87,0,0,1-.87-.87V15.27a.87.87,0,0,1,1.73,0v1.11a.87.87,0,0,1-.86.87Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140034",
    "data-name": "Path 140034",
    d: "M29.1,22.51a.71.71,0,0,1-.31-.08,8,8,0,0,0-7.58,0,.643.643,0,1,1-.63-1.12,9.36,9.36,0,0,1,8.84,0,.65.65,0,0,1,.24.87.64.64,0,0,1-.56.33Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140035",
    "data-name": "Path 140035",
    d: "M25,3.31a22,22,0,1,1-22,22,22,22,0,0,1,22-22m0-2a24,24,0,1,0,24,24A24,24,0,0,0,25,1.31Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140036",
    "data-name": "Path 140036",
    d: "M8.8,42.06a1,1,0,0,1-1-1V38.3A10.73,10.73,0,0,1,18.52,27.58h.7a1,1,0,0,1,.43.1,12.06,12.06,0,0,0,10.69,0,1.13,1.13,0,0,1,.44-.1h.7A10.73,10.73,0,0,1,42.2,38.3v2.76a1,1,0,0,1-2,0V38.3a8.73,8.73,0,0,0-8.72-8.72H31a14,14,0,0,1-12,0h-.48A8.73,8.73,0,0,0,9.8,38.3v2.76a1,1,0,0,1-1,1Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140037",
    "data-name": "Path 140037",
    d: "M16.54,46.66a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,1,0v6A.5.5,0,0,1,16.54,46.66Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140038",
    "data-name": "Path 140038",
    d: "M33.5,46.66a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,1,0v6A.5.5,0,0,1,33.5,46.66Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11748",
    "data-name": "Ellipse 11748",
    cx: 9.52,
    cy: 9.39,
    rx: 9.52,
    ry: 9.39,
    transform: "translate(14.48 28.91)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140039",
    "data-name": "Path 140039",
    d: "M25,50A10.39,10.39,0,1,1,35.52,39.61,10.39,10.39,0,0,1,25,50Zm0-18.77a8.39,8.39,0,1,0,8.52,8.38A8.39,8.39,0,0,0,25,31.23Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140040",
    "data-name": "Path 140040",
    d: "M25,45.62a1.89,1.89,0,1,1,1.346-.543A1.88,1.88,0,0,1,25,45.62Zm-1.11-12h2.22a.56.56,0,0,1,.57.59l-.32,6.38a.57.57,0,0,1-.57.54H24.21a.57.57,0,0,1-.57-.54l-.32-6.38a.56.56,0,0,1,.57-.6Z",
    transform: "translate(-1 -1.31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdNewuserFail);
export default __webpack_public_path__ + "static/media/ic_md_newuser_fail.e137d2017925c1d9a8a5d2bd9b3cd679.svg";
export { ForwardRef as ReactComponent };